import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import axios from "utils/axios";
import { api } from "config/api.config";
import useWorkflowsStore from "./workflows.store";
import { DynamicMenuResponse, PrivateApps, QueryOptions } from "./workflows.types";

const dynamicMenu = "dynamicMenu";
export const dynamicMenuQueryKeys = {
  root: [dynamicMenu],
  fetchDynamicMenu: [dynamicMenu, 'fetchDynamicMenu'],
};

export const useFetchDynamicMenu = (
  useCustomDynamicMenu: boolean,
  config?: QueryOptions,
): UseQueryResult => {
  return useQuery({
    // The flag is part of the key so the menu refetches the correct endpoint
    // once `identify()` resolves the LaunchDarkly context for the real user.
    queryKey: [...dynamicMenuQueryKeys.fetchDynamicMenu, useCustomDynamicMenu],
    queryFn: async () => {
      // The custom-dynamic-menu endpoint serves CUSTOM_FLOW items; gate it on
      // the LaunchDarkly flag, falling back to the legacy endpoint.
      const url = useCustomDynamicMenu ? api.CUSTOM_DYNAMIC_MENU : api.DYNAMIC_MENU;
      const { data }: AxiosResponse<DynamicMenuResponse> = await axios.get(url);
      useWorkflowsStore.getState().setDynamicMenu(data.sideMenu);
      return data;
    },
    ...config,
  });
};

const privateApps = "privateApps";
export const privateAppsQueryKeys = {
  root: [privateApps],
  fetchPrivateApps: [privateApps, 'fetchPrivateApps'],
};

export const useFetchPrivateApps = (config?: QueryOptions): UseQueryResult => {
  return useQuery({
    queryKey: privateAppsQueryKeys.fetchPrivateApps,
    queryFn: async () => {
      const { data }: AxiosResponse<PrivateApps> = await axios.get(api.PRIVATE_APPS);
      useWorkflowsStore.getState().setPrivateApps(data);
      return data;
    },
    ...config,
  });
};